import { FormikHelpers } from 'formik'

import EfiPay from 'payment-token-efi'

import { useMutationPostPaymentCreditCard } from '@/api/payment/mutations'
import { useToast } from '@/contexts/ToastContext'

import { CardFormData } from './types'

export const useCardAddFormSubmit = (onSuccess: (cardId?: number) => void) => {
  const { show } = useToast()
  const { mutateAsync: mutatePostPaymentCreditCard } = useMutationPostPaymentCreditCard()

  const handleSubmit = async (values: CardFormData, { setSubmitting }: FormikHelpers<CardFormData>) => {
    setSubmitting(true)

    try {
      const cardBrand = await EfiPay.CreditCard.setCardNumber(values.card_number).verifyCardBrand()

      if (cardBrand === 'undefined' || cardBrand === 'unknown') {
        show('O cartão informado é inválido!', { severity: 'error' })
        return
      }

      const efiAccount = process.env.REACT_APP_EFI_ACCOUNT
      const efiEnvironment = process.env.REACT_APP_EFI_ENV || 'sandbox'

      if (!efiAccount) {
        show('Ocorreu um erro ao obter os dados para adicionar o cartão!', { severity: 'error' })
        return
      }

      const response = await EfiPay.CreditCard.setAccount(efiAccount)
        .setEnvironment(efiEnvironment)
        .setCreditCardData({
          brand: cardBrand,
          number: values.card_number.replace(/\s/g, ''),
          cvv: values.card_cvv,
          expirationMonth: values.card_expiration.split('/')[0],
          expirationYear: `${new Date().getFullYear().toString().slice(0, 2)}${values.card_expiration.split('/')[1]}`,
          reuse: true,
          holderDocument: values.cpf.replace(/\D/g, ''),
          holderName: values.name,
        })
        .getPaymentToken()

      const { payment_token, card_mask } = response as EfiPay.CreditCard.PaymentTokenResponse

      const { id: cardId } = await mutatePostPaymentCreditCard({
        token: payment_token,
        brand: cardBrand,
        cpf: values.cpf.replace(/\D/g, ''),
        name: values.name,
        card_mask,
        expiration_month: values.card_expiration.split('/')[0],
        expiration_year: values.card_expiration.split('/')[1],
        address_street: values.address_street,
        address_number: values.address_number,
        address_neighborhood: values.address_neighborhood,
        address_zip: values.address_zip.replace(/\D/g, ''),
        address_city: values.address_city,
        address_state: values.address_state,
      })

      show('Cartão adicionado com sucesso!', { severity: 'success' })

      onSuccess(cardId)
    } catch (error: unknown) {
      const err = error as EfiPay.CreditCard.ErrorResponse

      if (err.error_description) {
        show(err.error_description, { severity: 'error' })
      } else {
        show('Ocorreu um erro ao adicionar o cartão!', { severity: 'error' })
      }
    } finally {
      setSubmitting(false)
    }
  }

  return handleSubmit
}
